
const digest = '12bbfd9aac4b14fa3af67f8d8221dd485ee7f363e1d13693e577b408e7291415';
const classes = {"wrapper":"_wrapper_ezj5j_1","item":"_item_ezj5j_6","title":"_title_ezj5j_18"};
const css = `._wrapper_ezj5j_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_ezj5j_1 ._item_ezj5j_6 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #eaedf3;
  padding: 20px 0;
  align-items: center;
  gap: 10px;
}
._wrapper_ezj5j_1 ._item_ezj5j_6:first-of-type {
  border-top: 0;
}
._wrapper_ezj5j_1 ._item_ezj5j_6 ._title_ezj5j_18 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  